import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import EnhancedTableHead from './Components/EnhancedTableHead'
import { styles } from './style'
import FileCopyTwoToneIcon from '@material-ui/icons/FileCopyTwoTone'

const defaultNoDataMessage = 'No Data'

const EnhancedTable = ({
  classes,
  headers,
  rows,
  totalRow = [],
  handleRequestSort,
  order,
  orderBy,
  resultPerPage,
  onChangePage,
  totalCount,
  onChangeRowsPerPage,
  page,
  onContextMenuRow,
  overHeaderComponent,
  onClickRow = () => {},
  rowsPerPageOptions = [10, 50, 100, 200],
  noDataMessage = defaultNoDataMessage,
  disablePagination,
  disableNoDataWrapper,
  collapsableTable,
  rowPrefixComponent,
  headerPrefixComponent,
}) => {
  const handleChangePage = (event, newPage) => {
    onChangePage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    onChangeRowsPerPage(event.target.value)
  }

  return (
    <div className={classes.root}>
      {rows && rows.length > 0 ? (
        <Paper className={classes.paper}>
          {overHeaderComponent}
          <TableContainer className={classes.tableWrapper}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={'small'}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                headCells={headers}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                collapsableTable={collapsableTable}
                headerPrefixComponent={headerPrefixComponent}
              />
              <TableBody>
                {rows.map((item, index) => {
                  return (
                    <React.Fragment>
                      <TableRow
                        className={classNames({
                          [classes.endedSequence]: item.params.disabled,
                          [classes.tableRow]: !collapsableTable,
                          [classes.highLight]: item.params.highLight,
                          [classes.highlightHardcodedComms]:
                            item.params.hasOwnProperty('editable') &&
                            !item.params.editable,
                          [classes.highlightExpandedRow]:
                            item.params.hasOwnProperty('editable') &&
                            item.params.editable &&
                            item.params.expandRow,
                        })}
                        tabIndex={-1}
                        key={item.params.id}
                        onContextMenu={
                          onContextMenuRow
                            ? event => onContextMenuRow(event, item)
                            : undefined
                        }
                      >
                        {rowPrefixComponent &&
                          rowPrefixComponent(
                            item.params.id,
                            item.params.editable,
                            item.params.selected,
                          )}

                        {Object.keys(item.row).map((value, i) => {
                          const isClickable = !item.params.disableClick.includes(
                            value,
                          )
                          return (
                            <TableCell
                              key={i}
                              dir="auto"
                              onClick={event =>
                                isClickable
                                  ? onClickRow(
                                      event,
                                      item.params.id,
                                      item.params.commType,
                                    )
                                  : null
                              }
                              className={classNames({
                                [classes.hover]: isClickable,
                                [classes.disableBorderBottom]: collapsableTable,
                                [classes.delayColumn]: value === 'commDelay',
                              })}
                              align={
                                value == 'nameSequence' || collapsableTable
                                  ? 'left'
                                  : 'center'
                              }
                            >
                              {item.row[value]}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                      {item.params.expandRow && item.params.collapsableInfo}
                    </React.Fragment>
                  )
                })}
                {totalRow.length > 0 && (
                  <TableRow
                    className={classNames({
                      [classes.row]: true,
                    })}
                    tabIndex={-1}
                  >
                    {totalRow.map((item, i) => (
                      <TableCell
                        key={i}
                        className={classNames({
                          [classes.hover]: false,
                        })}
                        align="center"
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {!disablePagination && (
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={totalCount}
              rowsPerPage={resultPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </Paper>
      ) : (
        <div className={!disableNoDataWrapper ? classes.noDataWrapper : ''}>
          <div className={classes.wrapper}>
            {noDataMessage === defaultNoDataMessage ? (
              <div className={classes.insideBlock}>
                <div>{defaultNoDataMessage}</div>
                <FileCopyTwoToneIcon color="#8A96A0" />
              </div>
            ) : (
              noDataMessage
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(EnhancedTable)
